import React from 'react';
import { PropTypes } from 'prop-types';

import AlertDialog from './AlertDialog';

const UpdateApprovalStatusModal = ({
  confirmHandler, dismissHandler, modal: { text: action, item, open },
}) => {
  const modalConfirmHandler = () => {
    confirmHandler(item)();
  };

  const modalDismissHandler = () => {
    dismissHandler();
  };

  const getActionFromStatus = (status) => {
    switch (status) {
    case 'APPROVED':
      return 'approve';
    case 'DISAPPROVED':
      return 'disapprove';
    default:
      return status ? status.toLowerCase() : null;
    }
  };

  const actionLabel = getActionFromStatus(action);
  const message = actionLabel ? `Are you sure you want to ${actionLabel} your selection?` : '';
  return (
    <AlertDialog
      open={!!open}
      confirmTitle="Confirm"
      onConfirmation={modalConfirmHandler}
      onDismiss={modalDismissHandler}
    >
      {message}
    </AlertDialog>
  );
};

UpdateApprovalStatusModal.propTypes = {
  modal: PropTypes.shape({
    text: PropTypes.string,
    open: PropTypes.bool,
    items: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    ),
  }),
  confirmHandler: PropTypes.func,
  dismissHandler: PropTypes.func,
};

export default UpdateApprovalStatusModal;
